import React, { useState, useEffect } from "react";
import ChequeImageViewer from "../../../../../../misc/modules/navigo-dashboard/components/helper/cheque-image-viewer";
import SecurePDFViewer from "../../../../../../misc/modules/navigo-dashboard/components/helper/secure-pdf-viewer";
import { Row, Col } from "react-flexbox-grid";
import { Button, CircularProgress } from "react-md";
import { Modal } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import {
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Menu,
  IconButton,
  InputLabel,
  FormControl,
  Box,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import {
  AccountBalanceOutlined,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import BankAccountService from "../services/BankAccountService";
import EventService from "../../../../../../../service/event/EventService";
import { errorMessageHandler } from "../../../../../../misc/modules/disqualification-module/utils/helperMethod";
import AddBankAccount from "../../../../../../misc/modules/navigo-dashboard/components/helper/add-bank-account";
import BankAccountSuccessScreen from "../../../../../../misc/modules/navigo-dashboard/components/helper/bank-account-success-screen";

const BankAccount = ({ open, close, patient }) => {
  const [fetchPrimarybankAccountResponse, setFetchPrimarybankAccountResponse] =
    useState(null);
  const [isBankAccountNotFoundError, setIsBankAccountNotFoundError] =
    useState(false);

  const [isBankAccountSuccessScreen, setIsBankAccountSuccessScreen] =
    useState(false);
  const [bankAccountOperation, setBankAccountOperation] = useState("");

  const [loading, setLoading] = useState(false);
  const [isChangeAccountScreen, setIsChangeAccountScreen] = useState(false);

  const bankAccountService = new BankAccountService();

  const ACCOUNT_TYPE_MAP = {
    1: "Savings",
  };

  const BANK_ACCOUNT_VERIFICATION_STATUS_VERIFIED = 1;
  const BANK_ACCOUNT_VERIFICATION_STATUS_UNVERIFIED = 0;
  const BANK_ACCOUNT_VERIFICATION_STATUS_REJECTED = 2;

  const getMaskedBankAccountNum = (last4, accNumLength) => {
    return "X".repeat(Math.abs(accNumLength - 4)) + (last4 ?? "").toString();
  };

  const getVerificationStatusColor = (verificationStatus) => {
    const colorMap = {
      0: "#FFBD2D",
      1: "#1BC47D",
      2: "#E44437",
    };
    return colorMap[verificationStatus ?? -1];
  };
  const getVerificationStatusLabel = (verificationStatus) => {
    const labelMap = {
      0: "Unverified",
      1: "Verified",
      2: "Rejected",
    };
    return labelMap[verificationStatus ?? -1];
  };

  const isZeroObjectId = (objId) => {
    const objectId = (objId ?? "").toString();
    if (!objectId) {
      return true;
    }
    if (objectId === "" || objectId === "000000000000000000000000") {
      return true;
    }
    return false;
  };

  const fetchMaskedPrimaryBankAccountForPatient = (pid) => {
    setLoading(true);
    setIsBankAccountNotFoundError(false);
    bankAccountService.fetchMaskedPrimaryBankAccountForPatient(
      pid,
      (res) => {
        setFetchPrimarybankAccountResponse(res);
        setLoading(false);
      },
      (err) => {
        const notFound = Boolean(err?.code === 404);
        setIsBankAccountNotFoundError(notFound);
        // A 404 just means the patient has no bank account yet — that's a normal
        // state the dialog handles ("Add bank account"), not an error to surface.
        if (!notFound) {
          EventService.emit("showError", {
            message:
              "Error fetching current bank account for the patient : " +
              errorMessageHandler(err).toString(),
          });
        }
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (patient?.id) {
      fetchMaskedPrimaryBankAccountForPatient(patient?.id);
    }
  }, [patient]);

  const handleCloseModal = () => {
    if (isBankAccountSuccessScreen) {
      setIsBankAccountSuccessScreen(false);
      setIsChangeAccountScreen(false);
    } else if (isChangeAccountScreen) {
      setIsBankAccountSuccessScreen(false);
      setIsChangeAccountScreen(false);
    } else {
      close();
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal}>
      {Boolean(loading) ? (
        <CircularProgress style={{ color: "orange" }} />
      ) : Boolean(isBankAccountSuccessScreen) ? (
        <BankAccountSuccessScreen
          heading={
            bankAccountOperation === "update"
              ? "Bank account changed successfully"
              : "Bank account added successfully"
          }
          onClickDone={handleCloseModal}
          handleCloseModal={handleCloseModal}
        />
      ) : Boolean(isChangeAccountScreen) ? (
        <AddBankAccount
          operation={bankAccountOperation}
          menuFor={{ patientId: patient?.id }}
          onSuccessfullSaveCallback={() => {
            fetchMaskedPrimaryBankAccountForPatient(patient?.id);
            setIsChangeAccountScreen(false);
            setIsBankAccountSuccessScreen(true);
          }}
          handleCloseModal={handleCloseModal}
        />
      ) : (
        <div
          style={{ width: "600px", left: "20%" }}
          className="custom-modal-content scrollable-modal-full-height"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "24px",
                fontWeight: 700,
                fontFamily: "Montserrat",
                textAlign: "center",
              }}
            >
              Bank account
            </div>

            <IconButton onClick={handleCloseModal}>
              <CloseIcon fontSize="large" />
            </IconButton>
          </div>

          {Boolean(fetchPrimarybankAccountResponse?.id) ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "32px",
                  paddingBottom: "0px",
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    overflow: "hidden",
                    border: "1px solid #CED4DA",
                    borderRadius: "4px",
                    paddingTop: "16px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingBottom: "16px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <div style={{ fontSize: 14 }}>Verification status</div>
                  <div
                    style={{
                      backgroundColor:
                        getVerificationStatusColor(
                          fetchPrimarybankAccountResponse?.verificationStatus
                        ) ?? "",
                    }}
                    onClick={() => {}}
                  >
                    <div
                      style={{
                        color: "white",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        border: "1px solid white",
                        borderRadius: "4px",
                        fontWeight: 700,
                      }}
                    >
                      {getVerificationStatusLabel(
                        fetchPrimarybankAccountResponse?.verificationStatus
                      ) ?? ""}
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "32px",
                  paddingTop: "16px",
                }}
              >
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  label="Full name as per bank account"
                  required
                  placeholder="Full name as per bank account"
                  value={
                    fetchPrimarybankAccountResponse?.accountHolderName ?? ""
                  }
                  disabled={true}
                />

                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Account type"
                  label="Account type"
                  required
                  value={
                    ACCOUNT_TYPE_MAP[
                      fetchPrimarybankAccountResponse?.accountType ?? -1
                    ] ?? ""
                  }
                  disabled={true}
                />
                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Bank account number"
                  required
                  label="Bank account number"
                  value={
                    getMaskedBankAccountNum(
                      fetchPrimarybankAccountResponse?.last4,
                      fetchPrimarybankAccountResponse?.accNumLength
                    ) ?? ""
                  }
                  disabled={true}
                />
                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="IFSC code"
                  required
                  label="IFSC code"
                  value={fetchPrimarybankAccountResponse?.ifsc ?? ""}
                  disabled={true}
                />
                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Bank name"
                  multiline
                  label="Bank name"
                  value={
                    fetchPrimarybankAccountResponse?.branchInfo?.bankName ?? ""
                  }
                  disabled={true}
                />
                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Branch name"
                  multiline
                  label="Branch name"
                  value={
                    fetchPrimarybankAccountResponse?.branchInfo?.branchName ??
                    ""
                  }
                  disabled={true}
                />
                <div style={{ height: "16px" }}></div>
                <TextField
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Branch address"
                  multiline
                  label="Branch address"
                  value={
                    fetchPrimarybankAccountResponse?.branchInfo?.address ?? ""
                  }
                  disabled={true}
                />

                <div style={{ height: "40px" }}></div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={(e) => {
                      setIsChangeAccountScreen(true);
                      setBankAccountOperation("update");
                    }}
                    className="full-width-button"
                    disabled={loading}
                    style={{
                      backgroundColor: loading ? "#e0e0e0" : "#f57c00",
                      color: "#fff",
                      marginTop: "20px",
                    }}
                  >
                    Change account
                  </Button>
                </div>
              </div>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "16px",
                  height: "360px",
                }}
              >
                <AccountBalanceOutlined
                  style={{ height: "160px", width: "160px", color: "#CED4DA" }}
                />
                <div>
                  {" "}
                  {Boolean(isBankAccountNotFoundError)
                    ? "No bank account added"
                    : " Unable to fetch bank account for this patient "}{" "}
                </div>
              </div>

              {Boolean(isBankAccountNotFoundError) && (
                <Button
                  fullWidth
                  variant="contained"
                  onClick={(e) => {
                    setIsChangeAccountScreen(true);
                    setBankAccountOperation("add");
                  }}
                  className="full-width-button"
                  disabled={loading}
                  style={{
                    backgroundColor: loading ? "#e0e0e0" : "#f57c00",
                    color: "#fff",
                    marginTop: "20px",
                  }}
                >
                  Add bank account
                </Button>
              )}
            </div>
          )}
        </div>
      )}
    </Modal>
  );
};

export default BankAccount;
